export function truncateHtml(html: string, maxWords = 100): string {
    const parts = html.split(/(<[^>]+>)/);
    let wordCount = 0;
    let result = '';
    for (const part of parts) {
        if (part.startsWith('<')) {
            result += part;
        } else {
            const words = part.split(/\s+/).filter(Boolean);
            const remaining = maxWords - wordCount;
            if (words.length >= remaining) {
                result += words.slice(0, remaining).join(' ') + ' …';
                return result;
            }
            wordCount += words.length;
            result += part;
        }
    }
    return result;
}
